import { IPlayerWithVideo } from '@voomly/player/funnel-deps';

// Subtitles story: we have to merge subtitles from the funnel and the node
// Subtitles on the node are the original ones (the same as on file)
// Subtitles on the funnel were edited by the user, and their ids are not real subtitles ids and
// their names could not match the original ones
export const prepareFunnelSubtitles = (
  funnelSubtitles: IPlayerWithVideo['subtitles'],
  nodeSubtitles: IPlayerWithVideo['subtitles']
): IPlayerWithVideo['subtitles'] => {
  return {
    defaultSubtitlesId: funnelSubtitles.defaultSubtitlesId,
    items: funnelSubtitles.items.map((funnelSubtitle) => {
      const nodeSubtitlesItem = nodeSubtitles.items.find(
        (nodeSubtitle) => nodeSubtitle.name === funnelSubtitle.name
      );

      return {
        name: funnelSubtitle.name,
        isEnabled: funnelSubtitle.isEnabled,
        isAutogenerated: !!nodeSubtitlesItem?.isAutogenerated,
        subtitlesId: nodeSubtitlesItem
          ? nodeSubtitlesItem.subtitlesId
          : funnelSubtitle.subtitlesId,
      };
    }),
  };
};
